import { Component } from 'vue-property-decorator';
import ResourceTable from '@centers/components/tables/resource-table/resource-table.vue';
import Vue from 'vue';

@Component({
  name: 'bpc-resources',
  components: {
    'bpc-resource-table': ResourceTable,
  },
})
export default class Resources extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
